import get from 'transmute/get';
import formatName from 'I18n/utils/formatName';
export const getAssigneeFullName = user => {
  const firstName = get('first_name', user);
  const lastName = get('last_name', user);
  return formatName({
    firstName,
    lastName
  });
};